import styled from 'styled-components';
import { Space, Text, Cross } from '@cashfree-intl/coherent';

export const StyledAlert = styled(Space)`
  padding: 0.6875rem 1rem;
  background: rgba(53, 192, 95, 0.1);
  border-radius: 0.375rem;
  margin-top: 1.75rem;
  svg {
    margin-top: 0.125rem;
  }
`;

export const StyledInstantRefundsBanner = styled.div`
  border-radius: 0.75rem;
  background: var(--GLOBAL_PANEL_BACKGROUND);
  box-shadow: 0px 0.25rem 0.5rem 0px rgba(0, 0, 0, 0.12);
  button {
    background: white;
  }
  & > div:first-child {
    padding-top: 1rem;
    padding-left: 2rem;
  }
  & > div:last-child {
    background: rgba(255, 255, 255, 0.12);
    border-top: 1px solid #492f79;
    padding: 0.875rem 0;
  }
  margin-bottom: 1rem;
`;

export const BannerText = styled(Text)`
  color: #e3defd;
`;

export const BannerBody = styled.div`
  margin-top: 1.25rem;
  margin-bottom: 1rem;
`;

export const TermsAndConditions = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  font-size: 0.75rem;
  sup {
    left: 0.125rem;
    top: -1px;
  }
`;

export const InstantRefundsOthersBanner = styled.div`
  border-radius: 0.75rem;
  background: var(--GLOBAL_PANEL_BACKGROUND);
  box-shadow: 0px 0.25rem 0.5rem 0px rgba(0, 0, 0, 0.12);
  button {
    background: white;
    max-height: 2.5rem;
  }
  .banner-desc {
    max-width: 70%;
  }
`;

export const InstantRefundsSubheading = styled(Text)`
  font-size: 1.125rem;
  font-weight: 600;
`;

export const StyledFooter = styled.div`
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  background: #fbf3e6;
  border-radius: 0px 0px 0.5rem 0.5rem;
  .w-400 {
    font-weight: 400;
  }
`;

export const InstantRefundsOthersBannerContent = styled.div`
  width: 100%;
`;

export const ActivationModalContent = styled.div`
  padding: 0.75rem;
  .pricing-header {
    padding-bottom: 3.125rem;
    .pricing-heading {
      font-size: 1.5rem;
      font-family: 'dm-sans';
    }
    .pricing-description {
      color: #d4e7ff;
      font-family: 'dm-sans';
      font-weight: 500;
      .bold {
        font-weight: 600;
      }
    }
    border-radius: 0.25rem;
    background: #023579;
    text-align: center;
    .pricing-description {
      margin-top: 0.75rem;
    }
  }
  .confirm-activation-button {
    max-width: 376px;
  }
`;

export const StyledPricingDiv = styled.div`
  padding: 0.75rem 20px;
  border-radius: 0.625rem;
  margin: -1.875rem 0.5rem 0 0.5rem;
  background: #fefdff;
  box-shadow: 0px 0.125rem 0.375rem 0px rgba(2, 53, 121, 0.16);
  & > div:first-child {
    margin-bottom: 0.375rem;
    font-weight: 500;
  }
  .w-500 {
    font-weight: 500;
  }
`;

export const StyledPricingDescription = styled(Text)`
  margin: 20px 0.5rem 2.625rem 0.5rem;
`;

export const StyledCross = styled(Cross)`
  width: auto;
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
`;

export const StyledCoachMarkTooltip = styled.div`
  border-radius: 0.5rem;
  background: linear-gradient(90deg, #240253 5.58%, #2b037b 91.7%);
  button {
    color: white;
    background: var(--PRIMARY);
  }
`;

export const StyledISActivationNote = styled(Text)`
  padding: 0 0.75rem;
`;
